import {
  createPromiseAction,
  rejectPromiseAction,
  resolvePromiseAction,
} from 'redux-saga-promise-actions'
import { call, put, takeEvery } from 'redux-saga/effects'
import { profileAPI } from '../../../api'
import {
  PROFILE_PASSWORD_UPDATE_REQUEST,
  PROFILE_PASSWORD_UPDATE_SUCCESS,
  PROFILE_PASSWORD_UPDATE_FAILED,
} from './actionTypes'

export const profilePasswordUpdatePA = createPromiseAction(
  PROFILE_PASSWORD_UPDATE_REQUEST,
  PROFILE_PASSWORD_UPDATE_SUCCESS,
  PROFILE_PASSWORD_UPDATE_FAILED
)()

function* update(action) {
  try {
    const response = yield call(profileAPI.updatePassword, action.payload)
    const { data } = response

    yield put(profilePasswordUpdatePA.success({}))

    resolvePromiseAction(action, {})
  } catch (error) {
    if (!error.response) {
      throw error
    }
    rejectPromiseAction(action, error.response.data)
  }
}

export function* updateSaga() {
  yield takeEvery(profilePasswordUpdatePA.request, update)
}
